// extracted by mini-css-extract-plugin
export default {"legendGreen":"CostAndMarginsChart_legendGreen__Og+Xz","legendOrange":"CostAndMarginsChart_legendOrange__Ncn3n","legendRed":"CostAndMarginsChart_legendRed__BxBVT"};